module.exports = __webpack_public_path__ + "media/images/recruit/section/mv_department_sp10-9cf0896d3848101552a14c962f73ba4f.jpg";